import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

const InspectPlc = () => {
  return (
    <>
      <h1>Inspect PLC (Dispatching Control)</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          // Configuration
          'PLC_CONFIG',

          // Status
          'PLC_STATUS',

          // Grid Metrics
          'PLC_GRID_METRICS',

          // PV Metrics
          'PLC_PV_METRICS',

          // KGJ Metrics
          'PLC_KGJ_METRICS',

          'PLC_DISTRIBUTION_METRICS',
        ]}
      />
    </>
  );
};

export default InspectPlc;
